import { animate } from 'animejs';

const fadeIn = (onBegin, onComplete) => {
  const el = document.querySelector('.loadScreen');
  if (!el) {
    onBegin?.();
    onComplete?.();
    return;
  }

  animate(el, {
    opacity: [1, 0],
    ease: 'linear',
    onBegin: () => onBegin?.(),
    onComplete: () => {
      el.style.display = 'none';
      onComplete?.();
    },
  });
};

const fadeOut = (onComplete) => {
  const el = document.querySelector('.loadScreen');
  if (!el) {
    onComplete?.();
    return;
  }

  // Cover immediately — no animation in this direction. The animated direction is
  // fadeIn (revealing the new page). Starting at opacity:0 and animating to 1 would
  // expose content behind the loadScreen for one frame, causing a visible flash.
  el.style.display = 'block';
  el.style.opacity = '1';
  onComplete?.();
};

export { fadeIn, fadeOut };